import styled from 'styled-components';

export const Toolbar = styled.div`
    position: relative;
    z-index: 999;
    display: flex;
    flex-wrap: wrap;
    align-items: flex-end;
    gap: 1.5rem;
    margin: 1.5rem 0 0;
    padding: 1.5rem 2rem;
    border-radius: 0.8rem;
    background: var(--bg-white, #fff);
    box-shadow: 0 0.2rem 0.6rem rgba(0, 0, 0, 0.12);

    label {
        display: flex;
        flex-direction: column;
        gap: 0.4rem;
        font-size: 1.2rem;
        color: var(--text-cor);
    }

    select,
    input {
        height: 3.6rem;
        min-width: 16rem;
        padding: 0 1rem;
        border: 1px solid var(--placeholder, #ccc);
        border-radius: 0.4rem;
        font-size: 1.4rem;
        color: var(--text-cor);
        background: transparent;
    }
`;

export const Resumo = styled.div`
    display: flex;
    gap: 2.5rem;
    margin-left: auto;

    div {
        display: flex;
        flex-direction: column;
        font-size: 1.2rem;
        color: var(--text-cor);
    }

    strong {
        font-size: 1.8rem;
    }
`;

export const BotaoConfiguracao = styled.button`
    height: 3.6rem;
    padding: 0 1.6rem;
    border: none;
    border-radius: 0.4rem;
    font-size: 1.4rem;
    color: #fff;
    background: var(--btn-admin-icone, #0056b3);
    cursor: pointer;
`;
